(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vetinn-sss"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vetinn-faq')) {
    class VetinnFaq extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this.controller) this.initialize();
        });
      }

      initialize() {
        this.tabs = Array.from(this.querySelectorAll('.vfaq__tab'));
        this.panels = Array.from(this.querySelectorAll('.vfaq__panel'));
        const tablist = this.querySelector('.vfaq__tabs');
        if (!tablist || !this.tabs.length) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab), options);

          tab.addEventListener('keydown', (event) => {
            let next;

            if (event.key === 'ArrowRight') {
              next = (index + 1) % this.tabs.length;
            }

            if (event.key === 'ArrowLeft') {
              next = (index + this.tabs.length - 1) % this.tabs.length;
            }

            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;

            event.preventDefault();
            this.activate(this.tabs[next]);
            this.tabs[next].focus();
          }, options);
        });

        this.activate(this.tabs[0]);
        tablist.hidden = false;
        this.setAttribute('data-enhanced', '');

        document.addEventListener('shopify:block:select', (event) => {
          if (!event.detail || String(event.detail.sectionId) !== this.dataset.sectionId) {
            return;
          }

          const question = Array.from(
            this.querySelectorAll('[data-block-id]')
          ).find(
            (item) => item.dataset.blockId === String(event.detail.blockId)
          );

          if (!question) return;

          const panel = question.closest('.vfaq__panel');
          const tab = this.tabs.find(
            (item) => item.getAttribute('aria-controls') === panel.id
          );

          if (tab) this.activate(tab);
          question.open = true;
          question.scrollIntoView({
            block: 'nearest',
            behavior: 'auto'
          });
        }, options);
      }

      activate(activeTab) {
        const panelId = activeTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const selected = tab === activeTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const tab = this.tabs.find(
            (item) => item.getAttribute('aria-controls') === panel.id
          );

          panel.hidden = panel.id !== panelId;
          panel.setAttribute('role', 'tabpanel');

          if (tab) panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
        });
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    }

    customElements.define('vetinn-faq', VetinnFaq);
  }

  } catch(e) { console.error(e); }
})();
})();
